import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const customExtensionCatalogPlugin = createPlugin({
  id: 'custom-extension-catalog',
  routes: {
    root: rootRouteRef,
  },
});

export const CustomExtensionCatalogPage = customExtensionCatalogPlugin.provide(
  createRoutableExtension({
    name: 'CustomExtensionCatalogPage',
    component: () =>
      import('./components/PluginInfoPage').then(m => m.PluginInfoPage),
    mountPoint: rootRouteRef,
  }),
);
